varying vec2 vUv; 
varying vec3 vPos; 
varying vec3 vNormal; 
#define PI 3.1415926538
uniform float u_time;
uniform float u_amplitude;
uniform float u_idea;
uniform float u_flat;
uniform float u_appear;

void main(){

    vec3 newPos = position; 
    float r = 0.5;
      vec3 dir = normalize(position);
    vec3 destroyedPos = dir*r;
float yNoise = (fract(sin(dot(position.xz, vec2(12.9898, 78.233))) * 43758.5453) - 0.5) * 2.0;
destroyedPos.y += (yNoise*0.01);

    // float angle = atan(newPos.z, newPos.x);
    // newPos += cos(angle);
    float angle = atan(newPos.x, newPos.z);
    vec2 radialDir = normalize(vec2(newPos.x, newPos.z));
float beFlatDisp = pow(-newPos.y, 3.0);

// Application du déplacement radial
if (newPos.y < 0.0) {
    newPos.x += radialDir.x * beFlatDisp * 20.0 * u_flat;
newPos.z += radialDir.y * beFlatDisp*20. * u_flat;

}

    angle += 0.5 * PI;

   
// Normaliser pour rester dans [-PI, PI]
if (angle > PI) {
    angle -= 2.0 * PI;
}

    float maskHeight = (1.-newPos.y-1.)*3.;
    maskHeight = clamp(maskHeight, 0., 1.);
    maskHeight *=abs(angle)/PI*0.5;
   maskHeight *=1.-(abs(angle)/PI);
    float displacement = angle < 0. ? cos(angle*10.+u_time)*(maskHeight) : cos(angle*10.-u_time)*(maskHeight);

    newPos.y += displacement*u_amplitude;


    vec3 wavePos = vec3(0., u_idea, 0.);
    float dist = distance(newPos, wavePos);
    float influence = 1.0 - smoothstep(0.0, 1., dist);
    newPos += normal * influence * 0.2;
    
    vec3 finalPos = mix(newPos, destroyedPos, 1.-u_appear);
    vec4 modelPosition = modelMatrix * vec4(finalPos, 1.0);



    vec4 viewPosition =  viewMatrix * modelPosition;
    vec4 projectedPosition = projectionMatrix * viewPosition;
    gl_Position = projectedPosition;


    // aditionnal calculations
    vUv = uv;
    vPos = position;
    vNormal = (modelMatrix * vec4(normal, 0.0)).xyz;
    // vNormal = normal;

}